import AcknowledgeCheckbox from './AcknowledgeCheckbox';

interface AcknowledgeCheckboxGroupProps {
	ack1: boolean;
	setAck1: (value: boolean) => void;
	ack2: boolean;
	setAck2: (value: boolean) => void;
	ack3: boolean;
	setAck3: (value: boolean) => void;
}

const AcknowledgeCheckboxGroup: React.FC<AcknowledgeCheckboxGroupProps> = ({
	ack1,
	setAck1,
	ack2,
	setAck2,
	ack3,
	setAck3,
}) => {
	return (
		<div className="acknowledge-checkbox-group">
			<AcknowledgeCheckbox
				id="ack-1"
				checked={ack1}
				onChange={() => setAck1(!ack1)}
				label="People on this account will immediately lose access."
			/>

			<AcknowledgeCheckbox
				id="ack-2"
				checked={ack2}
				onChange={() => setAck2(!ack2)}
				label="Your account will be accessible for 60 days in case you would like to reactivate it."
			/>

			<AcknowledgeCheckbox
				id="ack-3"
				checked={ack3}
				onChange={() => setAck3(!ack3)}
				label="Your outstanding balance will be charged at the beginning of the next month."
			/>
		</div>
	);
};

export default AcknowledgeCheckboxGroup;
